import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../css/PagesNav.css";

const isLinkActive = (to, location) => {
  if (typeof to !== "string") return false;
  const [pathname, query = ""] = to.split("?");
  if (location.pathname !== pathname) return false;
  const expected = new URLSearchParams(query);
  if ([...expected.keys()].length === 0) return true;
  const current = new URLSearchParams(location.search);
  return [...expected.entries()].every(
    ([key, value]) => current.get(key) === value
  );
};

const PagesNav = ({ links = [] }) => {
  const location = useLocation();
  const linkCount = links.length || 1;


  return <>
  <section className='NavHub'>
    <div className='d-flex justify-content-center'>
    <div className="navContainer" style={{ width: "100%" }}>
      {links.map((link, index) => (
        <label
          className="itemContainer"
          key={index}
          style={{ flex: `1 0 ${100 / linkCount}%` }}
        >
          <Link
            to={link.to}
            onClick={link.onClick}
            className={`item ${isLinkActive(link.to, location) ? "checked" : ""}`}
          >
            {link.icon && <img src={link.icon} className="icon" alt="" />}
            {link.name}
          </Link>
        </label>
      ))}
    </div>
    </div>
  </section>
  </>
};

export default PagesNav;
